import { GetUpsellModuleDataQuery } from 'src/services/graphql/generated/graphql';

type FindLatestPurchasePriceProps = {
    preApprovalLetters: NonNullable<
        NonNullable<
            NonNullable<GetUpsellModuleDataQuery['homeLoansDashboardByLoanId']>['currentlySelectedLoan']
        >['preApprovalLetters']
    > | null;
};

export const findLatestPurchasePrice = ({ preApprovalLetters }: FindLatestPurchasePriceProps) => {
    const mostRecentPreApprovalLetter = [...(preApprovalLetters ?? [])].sort(
        (a, b) => new Date(b?.metaData?.issueDate ?? 0).getTime() - new Date(a?.metaData?.issueDate ?? 0).getTime()
    )[0];

    return mostRecentPreApprovalLetter?.metaData?.purchasePrice ?? null;
};
